<template>
  <div>
    <div class="app">
      <main-navigation v-if="!isGuest" />
      <main-window :is-guest="isGuest" :class="{ 'nav-open': navIsOpen }" />
    </div>
    
    <dialogs-wrapper class="modal-dialogs" name="default" transition-name="fade" />
    <modal-wrapper name="default" />
    <toaster position="bottom center" :max="1" />
  </div>
</template>

<script>
import MainNavigation from './layout/MainNavigation'
import MainWindow from './layout/MainWindow'

export default {

  components: {
    MainNavigation,
    MainWindow,
  },

  data: () => ({
    navIsOpen: false,
  }),

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.restrainSidebar)
      this.restrainSidebar()
      this.$router.afterEach((to, from, next) => {
        this.restrainSidebar()
      })
    })

    this.$bus.$on('toggle-nav', () => {
      this.toggleSidebar()
    })
  },

  methods: {
    authCheck() {
      if (this.isGuest) {
        this.closeSidebar()
      }
    },
    closeSidebar() {
      this.navIsOpen = false
      this.$emit('close')
    },
    openSidebar() {
      this.navIsOpen = true
      this.$emit('open')
    },
    toggleSidebar() {
      if (this.navIsOpen === false) {
        this.openSidebar()
      } else {
        this.closeSidebar()
      }
    },
    restrainSidebar() {
      if (this.isGuest) {
        this.closeSidebar()
        return
      }
      if (document.documentElement.clientWidth <= 1024 && this.navIsOpen === true) {
        this.closeSidebar()
      }
      if (document.documentElement.clientWidth >= 1024) {
        this.openSidebar()
      }
    },
  },

  computed: {
    activeClass() {
      return {
        'is-active': this.navIsOpen,
      }
    },

    isGuest() {
      if(['signin', 'signup', 'device', 'forgot-password', 'reset-password', '2fa-challenge'].includes(this.$route.name)) {
        this.navIsOpen = false
        return true
      }

      return false
    },
  },

  watch: {
    $route: 'authCheck',
  },
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
</style>
